<template>
	<div class="main-layout">
		<ul class="navigation">
			<li class="title">
				<img src="../assets/logo32.png" />Destiny Loot History</li>
			<li v-for="route of routes">
				<v-link v-bind:href="route.path">{{ route.name }}</v-link>
			</li>
		</ul>

		<slot></slot>
	</div>
</template>

<script>
	import VLink from '../components/VLink.vue'

	export default {
		data() {
			return {
				routes: [{
						path: '/',
						name: "Home"
					},
					{
						path: '/collection',
						name: "Collection"
					},
					{
						path: '/history',
						name: "History"
					},
					{
						path: '/about',
						name: "About"
					}
				]
			}
		},
		components: {
			VLink
		}
	}
</script>

<style>
	body {
		background: url(../assets/gradient_green.jpg) no-repeat center center fixed;
		background-size: 100% 100%;
		height: 100%;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: 0;
		overflow: hidden;
		font-family: "Segoe UI", Tahoma, sans-serif;
		font-size: 75%;
	}

	.main-layout {
		display: flex;
		height: 100%;
		flex-direction: column;
		overflow: hidden;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}

	.navigation {
		list-style-type: none;
		background: rgba(0, 0, 0, 0.5);
		margin: 0;
		cursor: default;
		padding: 0;
		-webkit-box-flex: 0;
		-webkit-flex: none;
		-ms-flex: none;
		flex: none;
	}


	.navigation li {
		display: inline-block;
		color: rgba(255, 255, 255, 0.4);
		text-transform: uppercase;
		font-weight: bold;
		font-family: Arial, Helvetica, sans-serif;
	}

	.navigation .title {
		padding-right: 5em;
		padding-left: 1em;
		color: rgba(255, 255, 255, 0.7);
		font-weight: normal;
		user-select: none;
		cursor: default;
	}

	.navigation .title img {
		vertical-align: middle;
		padding-right: 1em
	}
</style>


// WEBPACK FOOTER //
// Main.vue?22b21f85